module.exports = __webpack_public_path__ + "static/media/china-final1.a1c6c9f2.png";